import React from 'react';
import { Flex, Box } from 'reflexbox';
import _ from 'lodash';
import reactFontFace from 'react-font-face';
import { FontConfig } from '../../../config/font';
import handleErrors from '../../utils/handleErrors';
import {CircularProgressEx} from '../../root/AppRoutes';
import {postApi} from '../../../config/api.js';
import SubTopMenu from '../../SubTopMenu';
import HashService from '../../../services/HashService';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => ({
  hash: state.hash,
  parentPage: state.parentPage
})

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      user: null
    };
  }

  handleDataLoading(userId) {
    const api = postApi + '/'+userId;
    fetch(api)
      .then(handleErrors)
      .then((data) => {
        this.setState({isLoaded: true, user: data});
      })
      .catch((error) => {
        //Todo: handle error here.
        //return {error: error, isLoaded: true};
    }) 
  }

  componentDidMount() {
    HashService.setHash('#Employee');
    HashService.setParentPage('Employee');

    const userId = this.props.match.params.id;
    if(!isNaN(userId)) {
      this.handleDataLoading(userId);
    }
  }

  onBackToEmployee = () => {
    window.history.back();
  }

  render() {
    const {user, isLoaded, error} = this.state;
    const thumbnail = _.get(user, 'meta_box.image_lists[0].full_url');

    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <CircularProgressEx />;
    } else {
      return (<Flex column auto style={styles.container} pt={30}>
        <Box>
          <SubTopMenu hash='Who'/>
        </Box>  
        <Flex pt={20} pl={150} wrap>
          <Box style={{backgroundColor: 'gray'}}>
            <img src={thumbnail} alt={user.title.rendered} style={{height: 500, zIndex: 99}}/>
            <div style={styles.info}>
              <span style={{textTransform: 'uppercase'}}>{user.title.rendered}</span><br />
              <span dangerouslySetInnerHTML={{__html: user.meta_box.job_title.replace(/(<([^>]+)>)/ig,"")}} />
            </div>
            <img src={require('../../../static/Assets/Images/shape/rectangle.png')} style={styles.rectangle} alt=''/>
          </Box>
          <Flex auto wrap column w={1 / 2} pr={60} style={{position: 'relative'}}>
            <Box><img src={require('../../../static/Assets/Images/Worker/Detail/flashtop.png')} height='100%' width='100%' alt='' /></Box>
            <Box pl={50} dangerouslySetInnerHTML={{ __html: user.content.rendered }} style={{fontSize: 14}}/>
            <Box pl={50}><img src={require('../../../static/Assets/Images/Worker/Detail/flashbottom.png')} width={600} style={styles.flashBottom} alt='' /></Box>
            <a style={styles.back} onClick={() => this.onBackToEmployee()}><img src={require('../../../static/Assets/Images/Worker/back.png')} alt=''/></a>
          </Flex>
        </Flex>
      </Flex>);
    }
  }
}

const styles = {
  rectangle: {
    zIndex: -1,
    position: 'absolute',
    marginLeft: -15,
    marginTop: -160
  },
  info: {
    zIndex: 99,
    textAlign: 'center',
    color: 'white',
    padding: '10px 0',
  },
  flashBottom: { verticalAlign: 'text-bottom' },
  container: {
    fontFamily: 'UTMAvoRegular',
    marginLeft: '5.3%',
    marginRight: '5.3%'
  },
  back: { position: 'absolute', bottom: 0, right: 0, cursor:'pointer'},
}

export default withRouter(connect(mapStateToProps)(reactFontFace(Profile, FontConfig)));


// WEBPACK FOOTER //
// ./src/components/Worker/detail/Profile.js